



























































































import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator'
import authService from '@/users/services/auth-service'

@Component
export default class ResetPasswordForm extends Vue {
  @Prop(String)
  private email!: string

  @Prop(String)
  private token!: string

  @Ref()
  private validator!: ValidationObserver

  private password = ''
  private passwordConfirmation = ''
  private serverError = ''
  private loggingIn = false

  @Watch('email')
  private emailChanged(val: string) {
    this.email = val
  }

  @Watch('token')
  private tokenChanged(val: string) {
    this.token = val
  }

  public async resetPassword() {
    this.loggingIn = true

    const res = await authService.resetPasswordAsync(
      this.email,
      this.token,
      this.password
    )

    this.loggingIn = false

    if (res[0]) {
      this.$router.push({
        name: 'login',
        params: {
          lang: this.$i18n.locale
        },
      })
    } else {
      this.serverError = res[1]
    }
  }
}
